import React from 'react';
import { Button as AntButton, ButtonProps as AntButtonProps } from 'antd';

interface CustomButtonProps extends Omit<AntButtonProps, 'type'> {
  label: string;
  buttonType?: 'primary' | 'secondary';
  noBorder?: boolean;
  customClass?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  label,
  buttonType = 'primary',
  noBorder = false,
  customClass,
  ...props
}) => {
  const buttonClass = `
    ${buttonType === 'primary' ? 'custom-primary-button' : 'custom-secondary-button'}
    ${noBorder ? 'no-border' : ''}
  `;

  return (
    <AntButton icon {...props} className={`${buttonClass} ${customClass}`}>
      {label}
    </AntButton>
  );
};

export default CustomButton;
